import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode");
  if (codeEntite) {
    config.headers["ref_entity"] = `client_${codeEntite}`;
  } else {
    config.headers["ref_entity"] = null;
  }

  // const sousEntiteId = localStorage.getItem("sousEntiteId")
  // if (sousEntiteId) {
  //   config.headers['etablissementId'] = `${sousEntiteId}`;
  // } else {
  //   config.headers['etablissementId'] =  null;
  // }

  return config;
});

const customHeader = {
  etablissementId: localStorage.getItem("sousEntiteId")
    ? localStorage.getItem("sousEntiteId")
    : null,
};

export const getListeElevePaginationOne = async (
  page,
  size,
  param = "",
  annee = "",
  niveau = ""
) => {
  return await axios.get(
    BASE_URL(
      `etablissement/listeeleves?anneeId=${annee}&niveauId=${niveau}&page=${page}&param=${param}&size=${size}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getListeEleveSearch = async (param = "") => {
  return await axios.get(
    BASE_URL(`etablissement/recherchereleveparparametre?param=${param}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getListeElevePagination = async (page, size, param = "") => {
  return await axios.get(
    BASE_URL(
      `etablissement/listeelevesavecparametre?page=${page}&param=${param}&size=${size}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getListeEleve = async () => {
  return await axios.get(BASE_URL(`etablissement/listeeleves`), {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const getListeEleveParAnnee = async (annee) => {
  return await axios.get(
    BASE_URL(`etablissement/listeelevesparannee/${annee}?page=0&size=100000`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const rechercherMontantRestantParService = async (
  annee,
  eleve,
  service
) => {
  return await axios.get(
    BASE_URL(
      `etablissement/resteapayereleves/?anneeId=${annee}&eleveId=${eleve}&serviceId=${service}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const ajoutEleve = async (values) => {
  return await axios.post(BASE_URL("etablissement/enregistrereleve"), values, {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const getExempleFichierChargerListeEleve = async () => {
  return await axios.get(BASE_URL("etablissement/telechargermodelfichier"), {
    responseType: 'blob', // Set the response type to 'blob'
  });
};

export const chargerFichierEleve = async (values) => {
  return await axios.post(
    BASE_URL("etablissement/chargerfichiereleves"),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const supprimerFichierEleve = async (values) => {
  return await axios.post(
    BASE_URL("etablissement/supprimereleves"),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const deleteEleve = async (id) => {
  return await axios.delete(BASE_URL(`etablissement/supprimereleve/${id}`), {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const getListeToutService = async () => {
  return await axios.get(BASE_URL(`etablissement/listeservices`), {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const getListeServiceNonAssocie = async (id) => {
  return await axios.get(
    BASE_URL(`etablissement/listeservicesnonassocies/${id}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getListeServiceNonAssocieParEleveParAnnee = async (
  annee,
  eleve
) => {
  return await axios.get(
    BASE_URL(
      `etablissement/servicesparannee?anneeId=${annee}&eleveId=${eleve}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getListeServiceAssocieParEleveParAnnee = async (annee, eleve) => {
  return await axios.get(
    BASE_URL(
      `etablissement/servicesassociesparannee/?anneeId=${annee}&eleveId=${eleve}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const associeServicePourEleve = async (values) => {
  return await axios.post(
    BASE_URL(`etablissement/associereleveaservices`),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const supprimeServiceAssocieEleve = async (annee, eleve, service) => {
  return await axios.post(
    BASE_URL(
      `etablissement/supprimerserviceeleve?anneeId=${annee}&eleveId=${eleve}&serviceId=${service}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};
